import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41711652"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "block cursor-pointer" }

import { computed } from "vue";
import { getIcon, Icon } from "@/assets/icons/icons";

export default /*#__PURE__*/_defineComponent({
  __name: 'LabelButton',
  props: {
    icon: {},
    label: {}
  },
  emits: ["click"],
  setup(__props: any) {



const icon = computed(() =>
  props.icon === undefined ? null : getIcon(props.icon)
);

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: "flex cursor-pointer text-center items-center justify-center hgreen"
  }, [
    (icon.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: icon.value,
          class: "px-xs cursor-pointer"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label ?? " "), 1)
  ]))
}
}

})